var map = {
	"./Group 255.png": 3013,
	"./Group 5.png": 1918,
	"./Livello 12.png": 2982,
	"./Livello 2-1.png": 7269,
	"./Vector.png": 425,
	"./coin2.png": 3637,
	"./coinstack2.png": 5470,
	"./comment.png": 4893,
	"./hand.png": 6399,
	"./heart-outline.png": 2843,
	"./heart.png": 8705,
	"./home-outline.png": 3175,
	"./home.png": 5325,
	"./info.png": 3619,
	"./link.png": 9323,
	"./mailbox-down.png": 770,
	"./mailbox-up.png": 8488,
	"./marker.png": 1975,
	"./miei concerti.png": 6200,
	"./mixer icon.png": 3448,
	"./partecipanti.png": 7154,
	"./post1-cc.png": 7027,
	"./post2-mr.png": 3860,
	"./post3-cp.png": 4553,
	"./post4-mt.png": 4520,
	"./share.png": 705,
	"./user-headphones.png": 4567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5437;